// Delikatne odsłanianie elementów `.rv` przy scrollu (zamiennik AOS: bez biblioteki, bez CSS 25 kB).
// Klasa `.js` na <html> ustawiana jest w <head> — bez JS treść jest po prostu widoczna.
export default class Reveal {
    constructor() {
        this.io = null;
    }

    init() {
        this.destroy();
        window.__rvReady = true;

        const els = Array.from(document.querySelectorAll('.rv:not(.is-in)'));
        if (!els.length) return;

        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || !('IntersectionObserver' in window)) {
            els.forEach(el => el.classList.add('is-in'));
            return;
        }

        this.io = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                const el = entry.target;
                el.classList.add('is-in');
                this.io.unobserve(el);

                // po zakończeniu animacji zdejmujemy klasy, by nie kolidowały z hoverem elementu (transition)
                const done = (e) => {
                    if (e.target !== el || e.propertyName !== 'opacity') return;
                    el.removeEventListener('transitionend', done);
                    el.classList.remove('rv', 'rv--fade', 'rv--left', 'rv--right', 'is-in');
                    el.style.removeProperty('--d');
                };
                el.addEventListener('transitionend', done);
            });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

        els.forEach(el => this.io.observe(el));
    }

    destroy() {
        if (this.io) {
            this.io.disconnect();
            this.io = null;
        }
    }
}
